import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, BookMarked } from "lucide-react";
import { authGoogleSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSessionUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clean the fragment so the token isn't left in the URL/history
    if (window.history.replaceState) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const data = await authGoogleSession(sessionId);
        setSessionUser(data.user);
        navigate("/", { replace: true });
      } catch (e) {
        setError("We couldn't complete Google sign-in. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 2200);
      }
    })();
  }, [navigate, setSessionUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-center">
      <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl" style={{ border: "1px solid rgba(216,182,106,0.35)" }}>
        <BookMarked className="h-6 w-6 text-gold-light" />
      </span>
      {error ? (
        <p className="text-sm text-muted-foreground">{error}</p>
      ) : (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin text-gold-light" /> Entering the archive…
        </div>
      )}
    </div>
  );
}
